// To be used for the heading part of
// everything except MF

import * as React from "react";
import moment from "moment";
import { toINR } from "../../../../service/numberFormat";

export interface IOpQuotesHeadingDskProps {
	dpNm: string;
	ltp?: string;
	chLTP?: string;
	chLTPPer?: string;
	exc?: string;
	ltt?: string;
	expiry?: string;
	dateRange?: string;
}

const OpQuotesHeadingDsk: React.FC<IOpQuotesHeadingDskProps> = props => {
	return (
		<div className="op_quotes_heading">
			<h1 className="symbol">{props.dpNm || "--"}</h1>
			{props.expiry && <div className="expiry">{props.expiry}</div>}
			{props.ltp && (
				<div className="ltp_change">
					<span className="ltp">{toINR(props.ltp)}</span>
					<span className={"change " + (+props.chLTP! > 0 ? "green" : +props.chLTP! < 0 ? "red" : "")}>{props.chLTP}</span>
					{props.chLTPPer && (
						<span className={"change " + (+props.chLTPPer! > 0 ? "green" : +props.chLTPPer! < 0 ? "red" : "")}>({props.chLTPPer}%)</span>
					)}
				</div>
			)}
			{props.dateRange && <div className="small">{props.dateRange}</div>}
			{props.exc && (
				<div className="small">
					On {props.exc} - {props.ltt ? moment(props.ltt).format("DD MMM YYYY, hh:mm:ss A") : "--"}
				</div>
			)}
		</div>
	);
};

export default OpQuotesHeadingDsk;
